import { useState } from "react";
import { Plus } from "lucide-react";
import { Shimmer } from "../Shimmer/Shimmer";
import { PricelistTable } from "../PricelistTable/PricelistTable";
import { PricelistModal } from "../PricelistModal/PricelistModal";
import { useCategoryMap } from "../../hooks/useCategoryMap";
import { usePricelistList } from "../../hooks/usePricelistList";
import "../RequestsSection/RequestsSection.scss";

export const PricelistSection = () => {
  const [createOpen, setCreateOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const { data, loading, error, refetch } = usePricelistList();
  const { resolveCategoryName } = useCategoryMap();

  return (
    <section className="requests-section requests-section--embedded" aria-label="Тарифы">
      <div className="requests-section-header">
        <h1 className="requests-section-title">Тарифы</h1>
        <button
          type="button"
          className="requests-section-create-btn"
          onClick={() => setCreateOpen(true)}
        >
          <Plus size={20} />
          <span>Создать тариф</span>
        </button>
      </div>

      {loading ? (
        <Shimmer rows={5} />
      ) : error ? (
        <div className="requests-section-error">
          <p className="requests-section-error__text">{error}</p>
          <button type="button" className="requests-section-error__retry" onClick={refetch}>
            Повторить
          </button>
        </div>
      ) : (
        <PricelistTable
          data={data}
          onRowClick={setSelectedId}
          resolveCategoryName={resolveCategoryName}
        />
      )}

      {createOpen && (
        <PricelistModal onClose={() => setCreateOpen(false)} onSaved={refetch} />
      )}

      {selectedId && (
        <PricelistModal
          pricelistId={selectedId}
          onClose={() => setSelectedId(null)}
          onSaved={refetch}
        />
      )}
    </section>
  );
};
